export var EActionTypes;

(function (EActionTypes) {
  EActionTypes["GET_ADDRESS_GEO_SUGGEST_REQUEST"] = "GetAddressGeoSuggestRequest";
  EActionTypes["GET_ADDRESS_GEO_SUGGEST_SUCCESS"] = "GetAddressGeoSuggestSuccess";
  EActionTypes["GET_ADDRESS_GEO_SUGGEST_FAILURE"] = "GetAddressGeoSuggestFailure";
})(EActionTypes || (EActionTypes = {}));